import { z } from 'zod'

import { dataSchema } from '@fortem-monorepo/react-spa'

export const customJobSchema = z.object({
  taskname: z.string().nonempty(),
  recipients: z
    .array(dataSchema)
    .min(1)
    .refine((lines) => {
      return lines.length > 1 ? lines.some((line) => line.logic) : true
    }, 'Recipient args must contain at least one logic value'),
  sender: z
    .array(dataSchema)
    .min(1)
    .refine((lines) => {
      return lines.length > 1 ? lines.some((line) => line.logic) : true
    }, 'Sender args must contain at least one logic value'),
  subject: z
    .array(dataSchema)
    .min(1)
    .refine((lines) => {
      return lines.length > 1 ? lines.some((line) => line.logic) : true
    }, 'Subject args must contain at least one logic value'),
  st_dt: z.date(),
  ed_dt: z.date().optional(),
})

export type CustomJobFormType = z.infer<typeof customJobSchema>
